/* v5 */
(function () {
  var T1 = 70000, T2 = 100000;

  function fmt(c) {
    return Math.round(c / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kr';
  }

  function updateAll(total) {
    var pct = Math.min((total / T2) * 100, 100);
    var text;
    if (total < T1) {
      text = '🛒 ' + fmt(T1 - total) + ' till <strong>10% rabatt</strong> på hela ordern';
    } else if (total < T2) {
      text = '✅ 10% aktiverad! ' + fmt(T2 - total) + ' till <strong>15% rabatt</strong>';
    } else {
      text = '🎉 15% rabatt aktiverad på hela ordern!';
    }
    // Uppdatera alla bars på sidan (produktsida + kundvagn)
    document.querySelectorAll('.prod-progress-bar-text, .cart-discount-text, #cart-discount-text').forEach(function(p) {
      p.innerHTML = text;
    });
    document.querySelectorAll('[data-discount-fill], .prod-progress-bar-fill, .cart-discount-fill, #cart-discount-fill').forEach(function(f) {
      f.style.width = pct + '%';
    });
  }

  function fetchAndUpdate() {
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(d) { updateAll(d.total_price); });
  }

  // Intercept fetch
  var oFetch = window.fetch;
  window.fetch = function(input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = oFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update)/.test(url)) {
      p.then(function() { setTimeout(fetchAndUpdate, 600); });
    }
    return p;
  };

  // Intercept XHR
  var oOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(m, url) {
    if (/\/cart\/(add|change|update)/.test(url)) {
      this.addEventListener('load', function() { setTimeout(fetchAndUpdate, 600); });
    }
    return oOpen.apply(this, arguments);
  };

  // MutationObserver - reagerar när Dawn uppdaterar totalsumman i kundvagnen
  function startObserver() {
    var target = document.querySelector('#main-cart-footer') || document.querySelector('.cart__footer');
    if (!target) return;
    new MutationObserver(function() {
      fetchAndUpdate();
    }).observe(target, { childList: true, subtree: true });
  }

  // Cart events
  ['cart:refresh', 'cart:updated', 'theme:cart:update'].forEach(function(e) {
    document.addEventListener(e, fetchAndUpdate);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { startObserver(); fetchAndUpdate(); });
  } else {
    startObserver();
    fetchAndUpdate();
  }
})();